define('viewmodels/app/__loginAndNavigationPanel',['knockout', 'jquery', 'lodash', 'postLogin/index', 'dataSource/session','./__subrouter'],
    function( ko, $, _, postLogin, session, router) {
        'use strict';

        var casLogoutTypes = {
            GLOBAL: '1',
            LOCAL: '0'
        };

        var casLogoutType = ko.observable(casLogoutTypes.LOCAL);

        var overlayVisible = ko.observable(false).extend({throttle:50});

        var isUserInfoShown = ko.observable(false);

        var overlayElement = ko.observable(null);

        var fullLoginName = ko.computed(getFullLoginName);

        var links = generateLinks(router);

        return {
            casLogout:casLogout,
            casLogoutType: casLogoutType,
            sessionData: session.session,
            toggleSidePanel: toggleSidePanel,
            fullLoginName:fullLoginName,
            overlayVisible:overlayVisible,
            overlayElement:overlayElement,
            isUserInfoShown: isUserInfoShown,
            links:links,
            handleNavigation:handleNavigation
        };

        function toggleSidePanel() {            
            $("#sidebarCollapseIcon").toggleClass("active");
            $("#navigationSidebar").toggleClass("active");
            $('#navigationSidebar').toggle('slide');
            $('#navigationSidebarMask').toggle('fade', {}, 200);
        }


        function generateLinks(router){
            var generatedLinks = [];
            _.forEach(router.routes,function(route){
                if(route.nav){
                    generatedLinks.push(route);
                }
            });
            return generatedLinks;
        }

        function handleNavigation(data){
            var isActive = data.isActive.peek();
            if(!isActive){
                router.navigate(data.hash);
                toggleSidePanel();
            }
        }

        function getFullLoginName(){
            return [session.session().firstName, session.session().lastName].join(' ');
        }

        function casLogout(){
            if(casLogoutType() === casLogoutTypes.GLOBAL){
                postLogin.allServicesLogout();
            } else {
                postLogin.thisServiceLogout();
            }
        }
    });
